"use client";
import { useEffect, useState } from "react";
//#region packages/@mantine/hooks/src/use-media-query/use-media-query.ts
function getInitialValue(query, initialValue) {
	if (typeof initialValue === "boolean") return initialValue;
	if (typeof window !== "undefined" && "matchMedia" in window) return window.matchMedia(query).matches;
	return false;
}
function useMediaQuery(query, initialValue, { getInitialValueInEffect } = { getInitialValueInEffect: true }) {
	const [matches, setMatches] = useState(getInitialValueInEffect ? initialValue : getInitialValue(query));
	useEffect(() => {
		try {
			if ("matchMedia" in window) {
				const mediaQuery = window.matchMedia(query);
				setMatches(mediaQuery.matches);
				const callback = (event) => setMatches(event.matches);
				mediaQuery.addEventListener("change", callback);
				return () => {
					mediaQuery.removeEventListener("change", callback);
				};
			}
		} catch (e) {
			return;
		}
	}, [query]);
	return matches || false;
}
//#endregion
export { useMediaQuery };

//# sourceMappingURL=use-media-query.mjs.map